import './utils/polyfills';

import { h, render } from 'preact';
import debounce from './utils/debounce';
import { Howler, Howl } from 'howler/src/howler.core.js';
import selectAll from './utils/select-all';
import RelatedStories from './components/related-stories';
import Swiper from 'swiper';

const mainContainer = document.querySelector('.main-container');
const nextButton = document.querySelector('#next-button');
const nextButtonIcon = nextButton.querySelector('.icon');
const nextButtonText = nextButton.querySelector('.js-next-button-text');
const prevButton = document.querySelector('#prev-button');
const replayButton = document.querySelector('#replay-button');

const relatedStories = document.querySelector('#related-stories-container');

let animationTimeout = null;
let relatedStoriesLoaded = false;
let activeAudioControlButton = null;

const navigator = window.navigator;
const isMobile = /Android/i.test(navigator.userAgent) || /iPhone|iPad|iPod/i.test(navigator.userAgent);

const slides = selectAll('.swiper-slide');
const howls = [];

initAudio();

function toggleAudioSvgs (button, state) {
  // first turn them all off
  selectAll('svg', button).forEach((svg) => svg.classList.add('hidden'));

  if (state === 'playing') button.querySelector('.audio-playing').classList.remove('hidden');
  if (state === 'muted') button.querySelector('.audio-muted').classList.remove('hidden');
  if (state === 'restart') button.querySelector('.audio-restart').classList.remove('hidden');
}

function initAudio () {
  slides.forEach((slide) => {
    const audioElement = slide.querySelector('.slide-audio');

    if (audioElement !== null) {
      const howl = new Howl({
        src: [
          audioElement.getAttribute('data-webm-audio-src'),
          audioElement.getAttribute('data-mp3-audio-src')
        ],
        volume: 0
      });

      slide._howl = howl;
      howls.push(howl);
    }
  });
}

function stopAllAudio () {
  howls.forEach((howl) => {
    if (howl.playing()) {
      howl.once('fade', () => {
        howl.stop();
      });

      howl.fade(1, 0, 300);
    }
  });
}

function clearAllTranscripts () {
  selectAll('.slide-transcript').forEach((transcript) => {
    transcript.innerHTML = '';
  });
}

if (isMobile) {
  slides[0].classList.add('swiper-no-swiping');
}

const swiper = Swiper('.swiper-container', {
  pagination: '.swiper-pagination',
  direction: 'vertical',
  speed: 600,
  slidesPerView: 1,
  mousewheelControl: true,
  keyboardControl: true,
  // Disable preloading of all images
  preloadImages: false,
  // Enable lazy loading
  lazyLoading: true,
  lazyLoadingInPrevNext: true,

  effect: 'fade',
  fade: {
    crossFade: false
  },

  nextButton: '#next-button',
  prevButton: '#prev-button'
});

swiper.on('slideChangeStart', () => {
  stopAllAudio();
});

swiper.on('slideChangeEnd', (instance) => {
  clearAllTranscripts();

  const activeIndex = instance.activeIndex;
  const activeSlide = instance.slides[activeIndex];
  const activeTranscript = activeSlide.querySelector('.slide-transcript');

  if (activeIndex + 1 === instance.slides.length - 1 && !relatedStoriesLoaded) {
    loadRelatedStories();
  }

  if (activeIndex > 0 && !instance.isEnd) {
    nextButtonText.textContent = 'Next';
    nextButtonIcon.classList.remove('icon--animated');
    nextButton.classList.remove('hidden');
    prevButton.classList.remove('hidden');
    replayButton.classList.add('hidden');

    if (animationTimeout) window.clearTimeout(animationTimeout);
  }

  if (activeSlide._howl) {
    const audioControlButton = activeSlide.querySelector('.slide-audio-control button');
    const slug = activeSlide.getAttribute('data-slug');
    const transcript = window.TRANSCRIPTS[slug];
    let int = null;

    const howl = activeSlide._howl;
    toggleAudioSvgs(audioControlButton, Howler._muted === true ? 'muted' : 'playing');

    const transcriptParagraph = document.createElement('p');
    const transcriptElement = document.createElement('span');
    transcriptParagraph.appendChild(transcriptElement);

    const startTranscript = function startTranscript () {
      if (!activeTranscript.contains(transcriptParagraph)) {
        activeTranscript.appendChild(transcriptParagraph);
      }

      return setInterval(() => {
        const position = howl.seek();
        let activeText = '';

        if (howl.playing()) {
          for (let i = 0; i < transcript.length; i++) {
            const entry = transcript[i];

            if (position < entry.time) {
              if (i > 0) {
                activeText = transcript[i - 1].text;
              } else {
                activeText = entry.text;
              }
              break;
            } else {
              activeText = entry.text;
            }
          }
        } else {
          activeText = '';
        }

        if (activeText.length !== 0) {
          transcriptElement.textContent = activeText;
        } else {
          activeTranscript.innerHTML = '';
        }
      }, 750);
    };

    clearInterval(int);
    int = startTranscript();

    const muteAudio = function () {
      if (Howler._muted === true) {
        Howler.mute(false);
      } else {
        Howler.mute(true);
      }

      toggleAudioSvgs(audioControlButton, Howler._muted === true ? 'muted' : 'playing');
    };

    audioControlButton.addEventListener('click', muteAudio, false);

    const restartAudio = function () {
      howl.seek(0);
      howl.play();
      toggleAudioSvgs(audioControlButton, Howler._muted === true ? 'muted' : 'playing');
      clearInterval(int);
      int = startTranscript();

      audioControlButton.addEventListener('click', muteAudio, false);
      audioControlButton.removeEventListener('click', restartAudio, false);
    };

    howl.on('play', () => {
      howl.fade(0, 1, 300);

      howl.once('end', () => {
        clearInterval(int);
        activeTranscript.innerHTML = '';
        toggleAudioSvgs(audioControlButton, 'restart');

        audioControlButton.removeEventListener('click', muteAudio, false);
        audioControlButton.addEventListener('click', restartAudio, false);

        animationTimeout = window.setTimeout(() => {
          nextButtonIcon.classList.add('icon--animated');
        }, 1000 * 10);
      });

      howl.once('stop', () => {
        clearInterval(int);

        audioControlButton.removeEventListener('click', muteAudio, false);
        audioControlButton.removeEventListener('click', restartAudio, false);
      });
    });

    howl.play();
  } else {
    animationTimeout = window.setTimeout(() => {
      nextButtonIcon.classList.add('icon--animated');
    }, 1000 * 20);
  }
});

swiper.on('reachBeginning', () => {
  nextButtonText.textContent = 'Begin';
  nextButtonIcon.classList.add('icon--animated');
  nextButton.classList.remove('hidden');
  prevButton.classList.add('hidden');
});

swiper.on('reachEnd', () => {
  nextButton.classList.add('hidden');
  replayButton.classList.remove('hidden');
});

function loadRelatedStories () {
  const url = 'https://www.texastribune.org/api/content/?content_type=story,audio,video,pointer&amp;tag=subject-bathroom-bill&amp;tag!=object-tribcast&amp;fields=id,url,readable_pub_date,seo_headline,short_summary,lead_art&amp;limit=4&amp;format=json';

  render(
    <RelatedStories
      src={url}
      numStories={isMobile ? 1 : 2}
      isColumn
    />,
    relatedStories
  );

  relatedStoriesLoaded = true;
}

function onAudioControlClick (e) {

}

replayButton.addEventListener('click', () => {
  nextButtonText.textContent = 'Begin';
  nextButton.classList.remove('hidden');
  replayButton.classList.add('hidden');

  swiper.slideTo(0, 0);
});

window.addEventListener('orientationchange', debounce(onResize, 300), { passive: true });

function onResize () {
  const windowHeight = window.innerHeight;
  mainContainer.style['max-height'] = `${Math.min(windowHeight, document.documentElement.clientHeight)}px`;

  for (let i = 0; i < slides.length; i++) {
    slides[i].style['max-height'] = `${windowHeight}px`;
  }

  swiper.update(true);
}



// WEBPACK FOOTER //
// ./main.js